import { TentativeBookingDTO, TravellerDTO } from "../../apiclient/ApiDtos";
import { SeatReservationFsmContext } from "../seatreservation/SeatReservationFsmContext";
import { WayPointSelectionFsmContext } from "../pickup-dropoff-order/WayPointsSelectionFsmContext";

export class TentativeBookingReviewFsmContext {
    constructor(
        public readonly tripCustomizationContext: SeatReservationFsmContext|WayPointSelectionFsmContext,
        public readonly travellerInfo: TravellerDTO,
        public readonly tentativeBooking: TentativeBookingDTO
    ) {}    

    withTravellerInfo(travellerInfo: TravellerDTO) {
        return new TentativeBookingReviewFsmContext(
           this.tripCustomizationContext, travellerInfo, this.tentativeBooking);
    }

    withTentativeBooking(tentativeBooking: TentativeBookingDTO) {
        return new TentativeBookingReviewFsmContext(
            this.tripCustomizationContext, this.travellerInfo, tentativeBooking); 
    }
}